<script>
	import {
		authenticated,
		LoadAuthData,
		loading,
		CurrentWindow,
	} from "./APIService";
	import Login from "./Login.svelte";
	import SearchUserWindow from "./SearchUserWindow.svelte";
	import Modal from "./Modal.svelte";
	import Navbar from "./Navbar.svelte";
	import GiftCode from "./GiftCode.svelte";
	import ClanWindow from "./ClanWindow.svelte";
	import HomeWindow from "./HomeWindow.svelte";
	import PurchaseTokenWindow from "./PurchaseTokenWindow.svelte";
	import PublicNews from "./PublicNewsWindow.svelte";
	import HistoryWindow from "./HistoryWindow.svelte";
	import WeeklyStatsWindow from "./WeeklyStatsWindow.svelte";
	import GetUserParallels from "./GetUserParallels.svelte";
	import FindMultipleUsers from "./FindMultipleUsers.svelte";
	import ExportFunFairWindow from "./ExportFunFairWindow.svelte"
	import ChatBan from "./ChatBan.svelte"
	import ReconnectBan from "./ReconnectBan.svelte"
	import CRMWindow from "./CRMWindow.svelte"
	import CRMReadyAnswers from "./CRMReadyAnswers.svelte"
	import CRMAiDrafts from "./CRMAiDrafts.svelte"

	LoadAuthData();
</script>

<svelte:head>
	<!-- elements go here -->
	<title>BingoSupport</title>
	<!--	<link href="css/bootstrap.min.css" rel="stylesheet">-->
	<!--	you can add items to index.html in public folder-->

	<link
		rel="apple-touch-icon"
		sizes="180x180"
		href="Images/apple-touch-icon.png"
	/>
	<link
		rel="icon"
		type="image/png"
		sizes="32x32"
		href="Images/favicon-32x32.png"
	/>
	<link
		rel="icon"
		type="image/png"
		sizes="16x16"
		href="Images/favicon-16x16.png"
	/>
	<link rel="manifest" href="Images/site.webmanifest" />
	<link rel="mask-icon" href="Images/safari-pinned-tab.svg" color="#5bbad5" />
	<meta name="msapplication-TileColor" content="#da532c" />
	<meta name="theme-color" content="#ffffff" />

	<style>
		body {
			background: rgb(241, 167, 6);
			background: url("/Images/FortuneWheelBackGround.png");
			background-repeat: repeat-y;
			background-size: cover;
			/*linear-gradient(90deg, rgba(241,167,6,0.8043418050814075) 0%, rgba(238,207,194,1) 100%);*/
		}
	</style>
</svelte:head>

{#if $loading?.isLoading === true}
	<div id="spinner" class="show">
		<img src="Images/ajax-loader.gif" />
	</div>
{/if}

<Modal></Modal>
{#if $authenticated.authenticated}
	<Navbar></Navbar>
{/if}

<div class="flex-wrapper">
	<div class="container">
		{#if $authenticated.authenticated}
			{#if $CurrentWindow === "SearchUserWindow"}
				<SearchUserWindow />
			{:else if $CurrentWindow === "GiftCode"}
				<GiftCode />
			{:else if $CurrentWindow === "ClanWindow"}
				<ClanWindow />
			{:else if $CurrentWindow == "HomeWindow"}
				<HomeWindow />
			{:else if $CurrentWindow == "PurchaseTokenWindow"}
				<PurchaseTokenWindow />
			{:else if $CurrentWindow == "PublicNews"}
				<PublicNews />
			{:else if $CurrentWindow == "HistoryWindow"}
				<HistoryWindow />
			{:else if $CurrentWindow == "WeeklyStatsWindow"}
				<WeeklyStatsWindow />
			{:else if $CurrentWindow == "GetUserParallels"}
				<GetUserParallels />
			{:else if $CurrentWindow == "FindMultipleUsers"}
				<FindMultipleUsers />
			{:else if $CurrentWindow == "ExportFunFairWindow"}
				<ExportFunFairWindow />
			{:else if $CurrentWindow == "ChatBan"}
				<ChatBan />
			{:else if $CurrentWindow == "ReconnectBan"}
				<ReconnectBan />
			{:else if $CurrentWindow == "CRMWindow"}
				<CRMWindow />
			{:else if $CurrentWindow == "CRMReadyAnswers"}
				<CRMReadyAnswers />
			{:else if $CurrentWindow == "CRMAiDrafts"}
				<CRMAiDrafts />
			{/if}
		{:else}
			<Login />
		{/if}
	</div>

	<div class="card-footer">
		<h6>SkyRampGames</h6>
	</div>
</div>

<style>
	.card-footer {
		color: #a8a7a7;
	}

	.flex-wrapper {
		display: flex;
		min-height: 100vh;
		flex-direction: column;
		justify-content: space-between;
	}

	.container {
		margin-top: 4%;
	}

	/* (A) FULL SCREEN WRAPPER */
	#spinner {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9999;
		width: 100vw;
		height: 100vh;
		background: rgba(0, 0, 0, 0.7);
		transition: opacity 0.2s;
	}

	/* (B) CENTER LOADING SPINNER */
	#spinner img {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%);
	}

	/* (C) SHOW & HIDE */
	#spinner {
		visibility: hidden;
		opacity: 0;
	}
	#spinner.show {
		visibility: visible;
		opacity: 1;
	}
</style>
